/**
 * Helpers for safe internal returnTo paths (list → detail → back).
 * Only relative same-app paths are accepted to avoid open redirects.
 */

const INTERNAL_PATH_RE = /^\/[A-Za-z0-9\-._~!$&'()*+,;=:@/?%]*$/

/**
 * @param {unknown} value
 * @param {string} [fallback='/']
 * @returns {string}
 */
export function sanitizeReturnTo(value, fallback = '/') {
  if (typeof value !== 'string') return fallback
  const trimmed = value.trim()
  if (!trimmed) return fallback
  if (!trimmed.startsWith('/')) return fallback
  if (trimmed.startsWith('//')) return fallback
  if (trimmed.includes('://')) return fallback
  if (!INTERNAL_PATH_RE.test(trimmed)) return fallback
  return trimmed
}

/**
 * @param {string} pathname
 * @param {string} [search=''] - with or without leading '?'
 * @returns {string}
 */
export function buildReturnTo(pathname, search = '') {
  const path = typeof pathname === 'string' && pathname.startsWith('/') ? pathname : '/'
  let q = typeof search === 'string' ? search : ''
  if (q && !q.startsWith('?')) q = `?${q}`
  if (q === '?') q = ''
  return sanitizeReturnTo(`${path}${q}`, path)
}

/**
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 * @returns {string}
 */
export function buildReturnToFromLocation(location) {
  if (!location) return '/'
  return buildReturnTo(location.pathname || '/', location.search || '')
}
